import { useTranslation } from '../i18n';
import type { SupportedLang } from '../i18n';

interface ILanguageSwitcherProps {
  testId?: string;
}

const LanguageSwitcher = ({ testId }: ILanguageSwitcherProps) => {
  const { lang, setLang, t } = useTranslation();

  const handleToggle = () => {
    const next: SupportedLang = lang === 'zh' ? 'en' : 'zh';
    setLang(next);
  };

  return (
    <button
      onClick={handleToggle}
      className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
      title={t('lang.switch')}
      data-testid={testId}
    >
      <svg
        className="w-3.5 h-3.5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802"
        />
      </svg>
      {lang === 'zh' ? 'EN' : '中文'}
    </button>
  );
};

export default LanguageSwitcher;
